function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useEffect, useState } from 'react';
import { Button, Tooltip } from 'antd';
import { YoutubeOutlined } from '@ant-design/icons';
import client from '../feathers';
var defaultYoutubeUrl = 'https://youtu.be/TkpHl9w2gbY';

var YoutubeButton = (_ref) => {
  var {
    endpointId,
    buttonStyle
  } = _ref;
  var [url, setUrl] = useState(defaultYoutubeUrl);
  useEffect(() => {
    function getYoutubeUrl() {
      return client.service('videos').find({
        query: {
          objectType: 'endpoints',
          objectId: endpointId
        }
      }).then((_ref2) => {
        var {
          data
        } = _ref2;
        var [video] = data;

        if (!video) {
          return;
        }

        var {
          youtubeUrl
        } = video;

        if (!youtubeUrl) {
          return;
        }

        setUrl(youtubeUrl);
      }).catch(() => {// do nothing
      });
    }

    getYoutubeUrl(); // setUrl(apiDocumentation);
  }, [endpointId]);

  var btnStyle = _objectSpread(_objectSpread({}, buttonStyle), {}, {
    href: url,
    target: '_blank',
    icon: /*#__PURE__*/React.createElement(YoutubeOutlined, null)
  });

  return /*#__PURE__*/React.createElement(Tooltip, {
    title: "View tutorial on Youtube"
  }, /*#__PURE__*/React.createElement(Button, btnStyle));
};

export default YoutubeButton;